/*eslint-disable*/
import React, { useState } from 'react'
import SerivceTable from '../../components/mastersComponent/services/serviceTable'
function Services(props) {
    const [searchValue, setsearchValue] = useState('')
    let handleSearch = (e, data) => {
        setsearchValue(data.value)
    }
    return (
        <React.Fragment>
            <div className="ag-theme-material agOver">
                <SerivceTable handleSearch={handleSearch} newPopup={() => setmodalOpen(true)} searchValue={searchValue} {...props} />
            </div>
        </React.Fragment>
    )
}

export default Services
